$( document ).ready( function() {

	// 일반형
	$('.summernote').summernote({
		lang: 'ko-KR',
		tabsize: 2,
		height: 200,
		minHeight: 100,
		maxHeight: 600,
		focus: false,
		dialogsInBody: true,
		dialogsFade: true,
		//disableDragAndDrop: true,
		fontNames: ['Nanum Barun Gothic','Arial', 'Arial Black', 'Comic Sans MS', 'Courier New', 'Merriweather'],
		fontNamesIgnoreCheck: ['Nanum Barun Gothic'],
        fontSizes: [ '8', '9', '10', '11', '12', '14', '16', '18', '24', '36' ],
		lineheight: 1.8,
		toolbar: [
			['fontsize', ['fontname','fontsize']],
			['style', ['bold', 'italic', 'underline', 'clear']],
			['font', ['strikethrough', 'superscript', 'subscript']],
			['color', ['color']],
			['table', ['table']],
			['para', ['ul', 'ol', 'paragraph']],
			['height', ['height','codeview']],
			['Insert',['picture']]
		],
		callbacks: {
			onInit: function() {
				if( $(this).attr('data-height') !== undefined ){
					$(".note-editable").last().css('height', $(this).attr('data-height'));
				};
			},
			onImageUpload: function(files) {
				for (var i = files.length - 1; i >= 0; i--) {
					summernoteUploadImage(files[i],this);
				}
			},
			onEnter: function(e) {
				e.shiftKey = true;
			}
		}
	});


	// 좁은형
	$('.summernoteMini').summernote({
		lang: 'ko-KR',
		tabsize: 2,
		height: 200,
		minHeight: 100,
		maxHeight: 600,
		focus: false,
		dialogsInBody: true,
		dialogsFade: true,
		//disableDragAndDrop: true,
		fontNames: ['Nanum Barun Gothic','Arial', 'Arial Black', 'Comic Sans MS', 'Courier New', 'Merriweather'],
		fontNamesIgnoreCheck: ['Nanum Barun Gothic'],
        fontSizes: [ '8', '9', '10', '11', '12', '14', '16', '18', '24', '36' ],
		lineheight: 1.8,
		toolbar: [
			['fontsize', ['fontname','fontsize']],
			['style', ['bold', 'underline', 'clear']],
			['color', ['color']],
			/*['table', ['table']],*/
			['para', ['ul', 'ol']],
			['height', ['height','codeview']],
			/*['Insert',['picture']]*/
		],
		callbacks: {
			onInit: function() {
				if( $(this).attr('data-height') !== undefined ){
					$(".note-editable").last().css('height', $(this).attr('data-height'));
				};
			},
			onImageUpload: function(files) {
				for (var i = files.length - 1; i >= 0; i--) {
					summernoteUploadImage(files[i],this);
				}
			},
			onEnter: function(e) {
				e.shiftKey = true;
			}
		}
	});


	// 에디터만
	$('.summernoteOnlyEdit').summernote({
		lang: 'ko-KR',
		height: 200,
		width: 200,
		minHeight: 200,
		maxHeight: 600,
		focus: false,
		dialogsInBody: true,
		dialogsFade: true,
		//disableDragAndDrop: true,
		fontNames: ['Nanum Barun Gothic','Arial', 'Arial Black', 'Comic Sans MS', 'Courier New', 'Merriweather'],
		fontNamesIgnoreCheck: ['Nanum Barun Gothic'],
        fontSizes: [ '8', '9', '10', '11', '12', '14', '16', '18', '24', '36' ],
		lineheight: 1.8,
		toolbar: [
		],
		callbacks: {
			onInit: function() {
				if( $(this).attr('data-height') !== undefined ){
					$(".note-editable").last().css('height', $(this).attr('data-height'));
				};
			},
			onImageUpload: function(files) {
				for (var i = files.length - 1; i >= 0; i--) {
					summernoteUploadImage(files[i],this);
				}
			},
			onEnter: function(e) {
				e.shiftKey = true;
			}
		}
	});

});


// 일반형
$('.summernoteBoard').summernote({
    lang: 'ko-KR',
    tabsize: 2,
    height: 500,
    minHeight: 100,
    maxHeight: 1000,
    focus: false,
    dialogsInBody: true,
    dialogsFade: true,
    //disableDragAndDrop: true,
    fontNames: ['Nanum Barun Gothic','Arial', 'Arial Black', 'Comic Sans MS', 'Courier New', 'Merriweather'],
    fontNamesIgnoreCheck: ['Nanum Barun Gothic'],
    fontSizes: [ '8', '9', '10', '11', '12', '14', '16', '18', '24', '36' ],
    lineheight: 1.8,
    toolbar: [
        ['fontsize', ['fontname','fontsize']],
        ['style', ['bold', 'italic', 'underline', 'clear']],
        ['font', ['strikethrough', 'superscript', 'subscript']],
        ['color', ['color']],
        ['table', ['table']],
        ['para', ['ul', 'ol', 'paragraph']],
        ['height', ['height','codeview']],
        ['Insert',['picture']]
    ],
    callbacks: {
        onInit: function() {
            if( $(this).attr('data-height') !== undefined ){
                $(".note-editable").last().css('height', $(this).attr('data-height'));
            };
        },
        onImageUpload: function(files) {
            for (var i = files.length - 1; i >= 0; i--) {
                summernoteUploadImage(files[i],this);
            }
        },
        onEnter: function(e) {
            e.shiftKey = true;
        }
    }
});




/* summernote 코드 삽입 */
function summernoteInsertText( codeId, formId ) {
	var code	= $(codeId).html();
	var org		= $(formId).val();
	$(formId).summernote("code", org + code);
}


/* summernote 이미지 업로드 및 삽입 */
function summernoteUploadImage(image, formId) {
	data = new FormData();
	data.append("image", image);
	$.post({
		url: "/upload",
		type: 'post',
		data: data,
		cache: false,
		contentType: false,
		processData: false,
		headers: {
			'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
		},
		success: function( data ) {
			$(formId).summernote("insertImage", '/storage/' + data, function (img) {
                img.css('width', '100%');
            });

		},
		error: function(data) {
			console.log(data);
		}
	});
}
